import $ from "jquery";
import { gsap } from 'gsap';
import {createCartController} from './cart/controller';
import {createCartStatus} from './cart/status';
import {copy} from './site.js';

export default function orderForm() {

    $('.orderform .sort-and-filter .top .button, .orderform .sort-and-filter .bottom .button').on('click', function () {
        $('.orderform .holder__filters').toggleClass('show')
        $('body').toggleClass('added-product')
    });

    $(document).on('click', function (e) {
        const $popup = $('.orderform .holder__filters');

        if (!$popup.hasClass('show')) return;

        const isInsidePopup = $(e.target).closest('.orderform').length > 0;
        const isCloseButton = $(e.target).closest('.orderform .close-filters, .orderform .holder__info-show-all').length > 0;

        if (!isInsidePopup || isCloseButton) {
            $('.orderform .holder__filters').toggleClass('show')
            $('body').toggleClass('added-product')
        }
    });

    const sortCheckboxes = document.querySelectorAll('input[name="sort[]"]');
    let sortOrderCheckbox = [];

    sortCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
            const checkmark = this.nextElementSibling;

            if (this.checked) {
                sortOrderCheckbox.push(this);
            } else {
                sortOrderCheckbox = sortOrderCheckbox.filter(item => item !== this);
            }

            sortOrderCheckbox.forEach((checkbox, index) => {
                checkbox.nextElementSibling.textContent = index + 1;
            });

            sortCheckboxes.forEach(cb => {
                if (!cb.checked) {
                    cb.nextElementSibling.textContent = '';
                }
            });
        });
    });

    let filters = [];
    let sortOrder = [];
    let showAddedOnly = false;
    let layoutReady = false;

    const container = $('.orderform .results');
    // Image frames have fixed dimensions; filters must not wait for every catalogue image.
    queueMicrotask(function () {
        container.isotope({
            itemSelector: '.results__item',
            layoutMode: 'fitRows',
            transitionDuration: '0.4s',
            hiddenStyle: {
                opacity: 0,
                transform: 'scale(0.98)'
            },
            visibleStyle: {
                opacity: 1,
                transform: 'scale(1)'
            },
            getSortData: {
                name: '.name',
                price: '[data-price] parseFloat',
                brand: '[data-brand]',
                category: '[data-category]',
                quantity: '[data-quantity] parseInt'
            },
            sortAscending: {
                name: true,
                price: true,
                brand: true,
                category: true,
                quantity: false
            }
        });

        container.isotope('on', 'arrangeComplete', function(filteredItems) {
            const totalVisible = filteredItems.length;
            $('.holder__info-show-all').text(copy('Show') + ' (' + totalVisible + ')');
        });

        layoutReady = true;
        runFilters();
    });

    const quickSearch = $('.quicksearch');
    quickSearch.keyup(debounce(function () {
        runFilters();
    }, 200));

    $('.filter-checkbox').on('change', function () {
        const val = $(this).parents('.holder__filter-item').data('filter-value');
        if (this.checked) {
            filters.push(val);
        } else {
            filters = filters.filter(f => f !== val);
        }
        runFilters();
        updateActiveCounts();
    });

    $('.sort-checkbox').on('change', function () {
        const val = $(this).data('sort-value');

        if (this.checked) {
            sortOrder.push(val);
            $(this).attr('data-sort-order', sortOrder.length);
        } else {
            sortOrder = sortOrder.filter(f => f !== val);
            $('.sort-checkbox').removeAttr('data-sort-order');
            sortOrder.forEach((s, i) => {
                $(`.sort-checkbox[data-sort-value="${s}"]`).attr('data-sort-order', i + 1);
            });
        }

        container.isotope({sortBy: sortOrder});
        updateActiveCounts();
    });

    let hasFilteredOnce = false;

    function runFilters() {
        const $totals = $('.orderform .totals');

        if (hasFilteredOnce) {
            gsap.to($totals, {
                opacity: 0,
                duration: 0,
                ease: 'power2.out'
            });
        }

        const regex = new RegExp(quickSearch.val(), 'gi');

        container.isotope({
            filter: function () {
                const $this = $(this);
                const text = $this.text() + JSON.stringify($this.data());
                const matchText = !quickSearch.val() || text.match(regex);

                const matchFilter = filters.length === 0 || filters.some(f => {
                    return typeof f === 'string' && $this.hasClass(f.replace('.', ''));
                });

                const quantityInput = $this.find('input.quantity-input');
                const quantity = parseInt(quantityInput.val(), 10) || 0;
                const matchQuantity = !showAddedOnly || quantity > 0;

                return matchText && matchFilter && matchQuantity;
            }
        });

        container.isotope('once', 'arrangeComplete', function () {
            if (hasFilteredOnce) {
                gsap.to($totals, {
                    opacity: 1,
                    duration: 0.2,
                    ease: 'power2.inOut'
                });
            }
            hasFilteredOnce = true;
        });
    }

    function debounce(fn, threshold = 100) {
        let timeout;
        return function debounced() {
            clearTimeout(timeout);
            const args = arguments;
            const _this = this;
            timeout = setTimeout(() => fn.apply(_this, args), threshold);
        };
    }

    $('.holder__info-reset').on('click', function () {
        filters = [];
        sortOrder = [];
        sortOrderCheckbox = [];

        $('.orderform input[type="checkbox"]').each(function () {
            this.checked = false;
            const checkmark = this.nextElementSibling;
            if (checkmark) {
                checkmark.textContent = '';
            }
            $(this).removeAttr('data-sort-order');
        });

        container.isotope({ filter: '*', sortBy: '' });
        quickSearch.val('');
        updateActiveCounts();
    });

    $('.filter-added').on('click', function () {
        showAddedOnly = !showAddedOnly;
        $(this).parents('.orderform').find('.filter-added').toggleClass('active', showAddedOnly);
        runFilters();
    });

    const root = document.querySelector('.orderform');
    const status = createCartStatus(root.querySelector('.results').parentElement);
    const money = cents => new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(cents / 100);
    const controller = createCartController({
        ...status,
        render(result) {
            const items = new Map(result.order.items.map(item => [Number(item.product), item]));
            $(root).find('.results__item').each(function () {
                const item = items.get(Number(this.dataset.productId));
                const quantity = item ? Number(item.quantity) : 0;
                this.dataset.quantity = quantity;
                if (item) this.dataset.cartItemId = item.id;
                else delete this.dataset.cartItemId;
                $(this).removeData('cart-item-id');
                $(this).find('.quantity-input').val(quantity);
                const price = $(this).find('.price').empty();
                const regular = Number(this.dataset.regularPrice) || 0;
                const amount = item ? Number(item.total_ex_tax) : Number(this.dataset.unitPrice);
                if (regular * (quantity || 1) > amount) $('<span class="before-price">').text(money(regular * (quantity || 1))).appendTo(price);
                $('<span class="current-price">').text(money(amount)).appendTo(price);
            });
            $(root).find('.totals-row.total .value').text(money(result.order.total));
            $(root).find('.totals-row.shipping .value').text(result.order.shipping === 0 ? copy('Free') : money(result.order.shipping));
            $(root).find('.totals').toggleClass('cart-is-empty', !result.order.items.length);
            if (layoutReady) {
                container.isotope('updateSortData');
                runFilters();
            }
        }
    });
    status.retry(() => controller.load());
    $(root).on('change', 'input.quantity-input', function () {
        if (this.closest('.is-cart-busy')) return;
        const product = Number(this.closest('.results__item').dataset.productId);
        controller.mutate('setProductQuantity', {product, quantity: Number(this.value)});
    });
    controller.load();

    function updateActiveCounts() {
        const activeFilters = $('.filter-checkbox:checked').length;
        const activeSorts = $('.sort-checkbox:checked').length;
        const totalActive = activeFilters + activeSorts;

        $('.sort-and-filter .active-count').each(function () {
            $(this).text(totalActive);
        });
    }


}
